import { CHANGE_TYPES } from '../components/StatisticsItem/StatisticsItem.constants';

export const getChangeType = (currentValue, previousValue) => {
  if (currentValue < previousValue) {
    return CHANGE_TYPES.FALL;
  } else if (currentValue > previousValue) {
    return CHANGE_TYPES.GROW;
  }
  return CHANGE_TYPES.SAME;
};
